export const enum PartOfSpeech {
  ADJECTIVE,
  ADVERB,
  CONJUNCTION,
  NOUN,
  NUMERAL,
  PREPOSITION,
  VERB,
}
